import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/Button';
import { Tooltip } from 'components/Tooltip';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import type { ReactNode } from 'react';

const DRAWER_SECTIONS = ['what', 'how', 'why'];

interface ArticleVisibilityInfoProps {
  titleTranslation: string;
  subTitleTranslation: string;
}

export function ArticleVisibilityInfo({ subTitleTranslation, titleTranslation }: ArticleVisibilityInfoProps) {
  return (
    <div className="flex flex-col gap-8">
      {DRAWER_SECTIONS.map(drawerSection => (
        <div key={drawerSection}>
          <div className="bg-snow-100 px-2">
            <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
              <FormattedMessage id={`${titleTranslation}.drawer.${drawerSection}.title`} />
            </Typography>
          </div>
          <div className="px-2">
            <Typography variant="body2" sx={{ mb: 3, fontWeight: 300, whiteSpace: 'pre-line' }}>
              <FormattedMessage id={`${subTitleTranslation}.drawer.${drawerSection}.description`} />
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
}

interface ArticleVisibilityInfoButtonProps {
  titleKey: string;
  subtitleKey?: string;
  children: ReactNode;
}

export function ArticleVisibilityInfoButton({
  titleKey,
  subtitleKey = undefined,
  children,
}: ArticleVisibilityInfoButtonProps) {
  const { openDrawer } = useInfoDrawer();

  return (
    <Tooltip tooltipContent={<FormattedMessage id={titleKey} />}>
      <Button
        id={titleKey}
        icon="InformationOutlined"
        onClick={() => openDrawer({ titleKey, subtitleKey, content: children })}
      />
    </Tooltip>
  );
}
